import { useEffect } from 'react';

/**
 * Hook that listens for notification click events and navigates to the clicked chat.
 * Extracted from NovaProvider to simplify the main component.
 */
export function useNotificationClickNavigation({
  onSelectChat,
  onOpenChat,
}: {
  onSelectChat: (chatUuid: string) => void;
  onOpenChat: () => void;
}): void {
  useEffect(() => {
    const handleNotificationClick = (event: Event) => {
      const customEvent = event as CustomEvent<{ chatUuid: string; chatTitle: string }>;
      const { chatUuid: clickedChatUuid } = customEvent.detail;

      if (clickedChatUuid) {
        onOpenChat();
        onSelectChat(clickedChatUuid);
      }
    };

    window.addEventListener('nova-chat-notification-click', handleNotificationClick);

    return () => {
      window.removeEventListener('nova-chat-notification-click', handleNotificationClick);
    };
  }, [onSelectChat, onOpenChat]);
}
